import {
   getDateFromDateObject,
   getNegPosDifferenceInDays,
   isCurrentYear
} from '@flowwai-frontend/shared/utils/common'

import { HOME_PAGE_DATE_TIME_FORMAT } from '@flowwai-frontend/shared/constants'
import { i18nType } from '../types/ToastTypes'

export const getRelativeDateAndTime = (
   date: Date,
   t: i18nType,

   format?: string,
   timeFormat?: string
): string => {
   const diffDays = getNegPosDifferenceInDays(
      getDateFromDateObject(new Date()),
      getDateFromDateObject(date)
   )

   if (diffDays === 0) {
      return `${t('today')} - ${getDateFromDateObject(date, timeFormat)}`
   } else if (diffDays === -1) {
      return `${t('yesterday')} - ${getDateFromDateObject(date, timeFormat)}`
   } else if (diffDays === 1) {
      return `${t('tomorrow')} - ${getDateFromDateObject(date, timeFormat)}`
   }

   return getDateFromDateObject(date, format)
}

export const getRelativeDay = (
   date: Date,
   t: i18nType,
   format?: string,
   currentYearFormat?: string
): string => {
   const diffDays = getNegPosDifferenceInDays(
      getDateFromDateObject(new Date()),
      getDateFromDateObject(date)
   )

   if (diffDays === 0) {
      return t('today')
   } else if (diffDays === -1) {
      return t('yesterday')
   } else if (diffDays === 1) {
      return t('tomorrow')
   }

   if (isCurrentYear(new Date(), date)) {
      return getDateFromDateObject(
         date,
         currentYearFormat || HOME_PAGE_DATE_TIME_FORMAT
      )
   }
   return getDateFromDateObject(date, format)
}

export function getDifferenceInMinutes(date1: Date, date2: Date) {
   if (!(date1 instanceof Date) || !(date2 instanceof Date)) {
      throw new Error('Both inputs must be Date objects.')
   }

   const diffInMilliseconds = Math.abs(date1.getTime() - date2.getTime())
   return Math.floor(diffInMilliseconds / (1000 * 60)) // Convert milliseconds to minutes
}
